import { Carousel } from 'react-responsive-carousel';

export default function LoginCarousel ()
{
return (
            <Carousel autoPlay={true} showThumbs={false} showStatus={false} showArrows={false}>
                <div>
                    <img src="https://kiaraapay.com/kiarafront/images/images/AEPS-01.jpg" style={{height:"412px"}} />
                </div>
                <div>
                    <img src="https://kiaraapay.com/kiarafront/images/images/Bill Payment-01.jpg" style={{height:"412px"}} />
                </div>
                <div>
                    <img src="https://kiaraapay.com/kiarafront/images/images/Credit Card Payment-01.jpg" style={{height:"412px"}} />
                </div>
                <div>
                    <img src="https://kiaraapay.com/kiarafront/images/images/DTH Payment-01-01.jpg" style={{height:"412px"}} />
                </div>
                <div>
                    <img src="https://kiaraapay.com/kiarafront/images/images/Loan Payment-01.jpg" style={{height:"412px"}} />
                </div>
                <div>
                    <img src="https://kiaraapay.com/kiarafront/images/images/Mobile Recharge-01.jpg" style={{height:"412px"}} />
                </div>
                <div>
                    <img src="https://kiaraapay.com/kiarafront/images/images/Money Transfer-01.jpg" style={{height:"412px"}} />
                </div>
                <div>
                    <img src="https://kiaraapay.com/kiarafront/images/images/UPI Payment-01.jpg" style={{height:"412px"}} />
                </div>
            </Carousel>
        );
}